import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import { allService } from '../../services';

export default function NewTransaction(props) {
  // Declaration of project constant
  const { showNewTransaction, setShowNewTransaction } = props;
  const { t } = useTranslation();
  const [timer, setTimer] = useState({ min: '05', sec: '00' });
  var interval = null;

  // Hide or show modal
  useEffect(() => {
    if (showNewTransaction === true) {
      $('.modal-transac').fadeIn();
    } else {
      console.log('off-paiement-modal');
      $('.modal-transac').fadeOut();
      clearInterval(interval);
      setTimer({ min: '05', sec: '00' });
    }
  }, [showNewTransaction]);

  // Hide modal
  function close() {
    $('.modal-transac').fadeOut();
    setShowNewTransaction(false);
  }

  function startTimer(duration) {
    var timer = duration,
      minutes,
      seconds;
    interval = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      setTimer({ min: minutes, sec: seconds });

      if (--timer < 0) {
        timer = duration;
      }
      return minutes;
    }, 1000);
  }

  useEffect(() => {
    startTimer(300);
  }, []);

  return (
    <div className="modal modal-transac">
      <div
        id="modal-transac"
        className="modal-content"
        style={{ overflow: 'auto' }}
      >
        <div style={{ textAlign: 'right' }}>
          <i
            className="icon ion-android-close close"
            id="close-user-edit"
            style={{
              color: 'inherit',
              float: 'right',
              fontWeight: 'bold',
              cursor: 'pointer',
              position: 'relative',
              top: '0px',
              left: '20px',
              visibility: 'hidden',
            }}
          />
        </div>
        <div className="display text-center" style={{ display: 'block' }}>
          <div
            className="mb-3 text-center"
            style={{ border: 'none', padding: 0, fontSize: '1.4em' }}
          >
            <div className="d-inline-block">
              <img
                src={props.transacData.paymentMethodImg}
                className="d-inline-block va-t mr-2 paiement-logo pr mb-3"
                style={{ width: '46px' }}
              />
              <h2 className="fw-800 lang mb-0 title" keyword="new-location">
                {t('Mobile_payment')}
              </h2>
              <span className="mr-2" style={{ fontSize: '0.65em' }}>
                {t('Awaiting_payment')}
              </span>
              <img
                src="/assets/img/paiement_loader.gif"
                className="pr"
                style={{ top: '1px' }}
              />
            </div>
          </div>
          <span>{t('Amount_to_pay')}</span>
          <h3 className="fw-800 mb-3">
            {allService.numberWithCommas(props.transacData.transacAmount)} FCFA
          </h3>
          <p>
            {t('Confirmation_message')}{' '}
            <strong>
              (+237) {allService.chunk(props.transacData.payerPhone, 3, ' ')}
            </strong>
            ;&nbsp;
            {t('Please_dial')}{' '}
            <strong>
              {props.paymentMethod ? props.paymentMethod.dial_code : ''}{' '}
            </strong>
            {t('to_confirm_pending')}
          </p>
        </div>
        <p
          className="p-2 text-center"
          style={{ color: '#0D47A1', background: '#E3F2FD' }}
        >
          <i className="icon ion-alert-circled mr-2" />
          {t('For_security_reasons')}{' '}
          <strong>
            {props.paymentMethod ? props.paymentMethod.provider : ''}{' '}
          </strong>
        </p>
        <button
          onClick={() => props.avortTransac()}
          className="col-12 col-md-6 col-lg-7 btn btn-primary btn-delete mb-4 text-uppercase"
          type="button"
          style={{ padding: '10px', margin: 'auto' }}
        >
          {/* <i className="icon ion-close-round mr-2" /> */}
          {t('Cancel')}
        </button>
        <div className="text-center">
          <span className="d-block m-auto" style={{ maxWidth: '300px' }}>
            {t('transaction_will_auto_cancle')}
          </span>
          <h1 className="fw-900 mt-1">
            {timer.min} : {timer.sec}
          </h1>
        </div>
      </div>
    </div>
  );
}
